var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.621 2.835H55.984L2.834 55.984v81l52.725 52.938h81.212l53.15-53.15V55.56l-52.3-52.725zm36.143 126.709l-44.221 44.221H63.212l-44.22-44.008V63.213l44.22-44.008h67.18l43.371 43.583v66.756h.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.656 75.117L45.388 52.156 28.592 67.889v56.339l16.158 16.37V85.747l14.032 31.252L74.726 75.33v87.378h17.858V29.621h-18.92L56.656 75.117zM105.072 29.621v133.087h20.41l38.693-38.48V96.164h-29.764v16.158h11.055c2.977-.426 3.189 2.977 1.062 5.527-2.125 2.551-23.598 23.599-23.598 23.599V50.881l25.086 26.149v6.378h16.158V68.526l-38.268-38.905h-20.834z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMg);
export default __webpack_public_path__ + "static/media/Mg.295fca81e204fefd9e1d21b7d2a364df.svg";
export { ForwardRef as ReactComponent };